import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  Paper,
} from '@mui/material';
import {
  CalendarToday,
  AccessTime,
  Smartphone,
  Store,
} from '@mui/icons-material';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Box
      sx={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        py: 8,
        mt: 8,
        minHeight: '80vh',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography
              variant="h2"
              component="h1"
              gutterBottom
              sx={{
                fontWeight: 'bold',
                mb: 3,
                fontSize: { xs: '2.5rem', md: '3.5rem' },
              }}
            >
              Book Your Next Appointment with Ease
            </Typography>
            
            <Typography
              variant="h5"
              sx={{
                mb: 4,
                opacity: 0.9,
                lineHeight: 1.6,
              }}
            >
              Simplifying appointment booking for clinics, beauty parlors, and salons. 
              Your time is valuable - book smart, book fast.
            </Typography>

            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
              <Button
                variant="contained"
                size="large"
                sx={{
                  backgroundColor: 'white',
                  color: 'primary.main',
                  '&:hover': { backgroundColor: '#f5f5f5' },
                  textTransform: 'none',
                  px: 4,
                  py: 1.5,
                  borderRadius: 3,
                  fontWeight: 'bold',
                }}
                onClick={() => scrollToSection('contact')}
              >
                Get Started
              </Button>
              
              <Button
                variant="outlined"
                size="large"
                sx={{
                  borderColor: 'white',
                  color: 'white',
                  '&:hover': { 
                    borderColor: 'white',
                    backgroundColor: 'rgba(255,255,255,0.1)'
                  },
                  textTransform: 'none',
                  px: 4,
                  py: 1.5,
                  borderRadius: 3,
                }}
                onClick={() => scrollToSection('services')}
              >
                Learn More
              </Button>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Paper
                  elevation={8}
                  sx={{
                    p: 3,
                    textAlign: 'center',
                    background: 'rgba(255,255,255,0.95)',
                    color: 'primary.main',
                    borderRadius: 3,
                  }}
                >
                  <CalendarToday sx={{ fontSize: 40, mb: 1 }} />
                  <Typography variant="h6" fontWeight="bold">
                    Slot Booking
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Reserve your preferred time
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={6}>
                <Paper
                  elevation={8}
                  sx={{
                    p: 3,
                    textAlign: 'center',
                    background: 'rgba(255,255,255,0.95)',
                    color: 'primary.main',
                    borderRadius: 3,
                    mt: 2,
                  }}
                >
                  <AccessTime sx={{ fontSize: 40, mb: 1 }} />
                  <Typography variant="h6" fontWeight="bold">
                    Walk-in Management
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Join virtual queue
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={6}>
                <Paper
                  elevation={8}
                  sx={{
                    p: 3,
                    textAlign: 'center',
                    background: 'rgba(255,255,255,0.95)',
                    color: 'primary.main',
                    borderRadius: 3,
                  }}
                >
                  <Smartphone sx={{ fontSize: 40, mb: 1 }} />
                  <Typography variant="h6" fontWeight="bold">
                    Mobile App
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Book anytime, anywhere
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={6}>
                <Paper
                  elevation={8}
                  sx={{
                    p: 3,
                    textAlign: 'center',
                    background: 'rgba(255,255,255,0.95)',
                    color: 'primary.main',
                    borderRadius: 3,
                    mt: 2,
                  }}
                >
                  <Store sx={{ fontSize: 40, mb: 1 }} />
                  <Typography variant="h6" fontWeight="bold">
                    For Businesses
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Streamline your workflow
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Hero;

